/**
 * Styled Components - Created by gustavomedina on 18/04/18.
 */
import styled from 'styled-components'
import InputComponent from 'antd/lib/input'
import InputPassword from 'antd/lib/input/Password'
import {
  WHITE,
  BLUE,
  RED,
  BLUE_LIGHTEST
} from '../../theme/colors'
import Icon from 'antd/lib/icon'
import Select from 'antd/lib/select'
import Button from 'antd/lib/button'
import Collapse from 'antd/lib/collapse'
import { SecondaryCTA, ContentInner } from '../../theme/components'

type DivProps = {
  secondary?: boolean
}

export const DarkBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
`

export const ClosedBanner = styled.div`
  position: fixed;
  background-color: ${BLUE_LIGHTEST};
  left: 0;
  right: 0;
  top: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  padding: 20px;

  a {
    color: ${BLUE};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--neutral-white);
`

export const BleedLayout = styled.div`
  width: 100%;
  max-width: 2860px;
  margin: 0 auto;
`

export const BodyShell = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--neutral-fill-lightest);
  width: 100%;
  padding: 10px 0 0;
  &.footer-body {
    background-color: var(--neutral-white);
  }
  @media (min-width: 320px) and (max-width: 748px) {
    padding: 0;
  }
`

export const ErrorTitle = styled.div`
  font-size: 18px;
  line-height: 33px;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  height: 70vh;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-flow: column;

  a {
    color: ${BLUE};
  }
`

export const NoStore = styled.img`
  max-width: 360px;
  margin-bottom: 10px;
`

export const AboutContainer = styled(ContentInner)`
  background: var(--neutral-white);
  padding-block: var(--spacing-64) 80px;
  #faqEyebrow {
    color: var(--neutral-secondary);
    font: 600 12px/20px var(--font-barlow);
    letter-spacing: 1px;
    margin-bottom: var(--spacing-6);
    text-transform: uppercase;
  }
  #faqTitle {
    color: var(--neutral-darkest);
    padding-bottom: var(--spacing-64);
    border-bottom: var(--border-regular) solid var(--neutral-border-med);
    font: 700 40px/42px var(--font-barlow-semi-condensed);
  }
  @media (max-width: 767px) {
    padding-block: var(--spacing-48) var(--spacing-64);
    #faqTitle {
      font: 700 28px / 34px var(--font-barlow-semi-condensed);
      padding-bottom: var(--spacing-40);
    }
  }
`

export const Accordion = styled(Collapse)`
  .ant-collapse-header {
    padding: var(--spacing-32) 0 !important;
  }
  .headerAccordion {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--neutral-darkest);
    font: 600 16px/22px var(--font-barlow);
    letter-spacing: -0.1px;
  }
  .ant-collapse-content-box {
    padding: 0 0 var(--spacing-24) !important;
    color: var(--neutral-body);
    font: 400 16px/24px var(--font-inter);
  }
  @media (max-width: 767px) {
    .headerAccordion, .ant-collapse-content-box {
      font-size: 14px;
    }
  }

`

export const IconExpand = styled(Icon)`
`

export const FlexContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  min-height: 90px;
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '12px' : '0px'};
  @media (max-width: 914px) {
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media (max-width: 764px) {
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 698px) {
    align-items: start;
  }
`

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-flow: column;
  @media (max-width: 698px) {
    width: 100%;
  }
`

export const CodeDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1140px) {
    flex-flow: column;
  }
  @media (max-width: 740px) {
    margin-top: 4px;
    flex-flow: column;
  }
`

export const PassCodeDiv = styled.div`
  max-width: 148px;
  @media (max-width: 1140px) {
    max-width: 82px;
  }
`

export const CodeLabel = styled.div`
  display: flex;
  background: #f4f4f4;
  padding: 8px 16px;
  border-radius: 25px;
  font-family: Avenir;
  font-size: 12px;
  overflow-wrap: break-word;
  white-space: break-spaces;
  align-items: center;
  @media (max-width: 598px) {
    margin-top: 12px;
    margin-right: 0;
    width: 100%;
    justify-content: center;
  }
`

export const CurrentTitle = styled.div`
  font-weight: 500;
  margin-right: 8px;
`

export const ResetButton = styled.div`
  border: 1px solid red;
  color: red;
  padding: 6px 12px;
  border-radius: 5px;
  margin-left: 12px;
  font-size: 12px;
  box-shadow: 1px 2px 2px 0px #e3e3e3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${RED};
    color: ${WHITE};
  }
  @media (max-width: 1140px) {
    margin-top: 12px;
  }
  @media (max-width: 914px) {
    margin-top: 0px;
  }
  @media (max-width: 740px) {
    margin-top: 12px;
  }
`

export const ListContainer = styled.div`
  padding-right: 0;
  width: 100%;
  margin-top: 28px;
  @media (min-width: 320px) and (max-width: 748px) {
    padding-left: 0;
    margin-top: var(--spacing-42);
  }
  .paginator {
    margin-top: -14px;
    padding-block: 24px;
  }
  .ant-pagination-item-link {
    border: unset;
    background-color: unset;
    :hover {
      color: var(--neutral-darkest);
    }
  }
  .ant-pagination-item {
    border-color: var(--neutral-lightest-block);
    :hover a {
      color: var(--neutral-darkest);
    }
  }
  .ant-pagination-item-active {
    border-color: var(--neutral-body);
    a {
      color: var(--neutral-darkest);
    }
  }
  #loader {
    position: relative;
    height: 0;
    display: flex;
    justify-content: center;
    z-index: 4;
  }
`

export const MoreItemsFloating = styled.div`
  position: fixed;
  bottom: 40px;
  background: #797979b8;
  backdrop-filter: blur(2px);
  z-index: 3;
  right: 20%;
  color: white;
  padding: 6px 10px;
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  box-shadow: 0px 2px 3px 0px darkgray;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.03);
    background: #797979ed;
  }
  @media (max-width: 768px) {
    right: calc(50% - 37px);
    bottom: 58px;
  }
  animation: bounce2 1.25s ease 0.25s both;
  @keyframes bounce2 {
    0% {
      opacity: 0;
      transform: translateY(0);
    }
    10% {
      opacity: 1;
    }
    25% {
      transform: translateY(-15px);
    }
    30% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-7px);
    }
    50%, 100% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(-15px);
    }
    80% {
      transform: translateY(0);
    }
    90% {
      transform: translateY(-7px);
    }
  }
`

export const DownArrow = styled(Icon)`
  background: #585858;
  border-radius: 25px;
  width: fit-content;
  color: #aaf6ff;
  padding: 4px;
  font-size: 12px;
  margin: 0 auto;
  margin-bottom: -14px;
  margin-top: 3px;
  box-shadow: 0px 2px 3px 0px darkgray;
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
`

export const TitlePassword = styled.div`
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 16px;
  text-align: left;
  margin-left: 8px;
`

export const PasswordBody = styled.div``

export const PasswordRecomendations = styled.div`
  font-size: 12px;
  margin-bottom: 16px;
  margin-left: 8px;
`

export const InputTitleContainer = styled.div`
  display: flex;
`

export const Label = styled.div`
  height: 20px;
  margin-left: 12px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const StyledInput = styled(InputPassword)`
  input {
    border-radius: 25px;
    margin-right: 14px;
    border: none;
    background: #f4f4f4;
    width: 100%;
    height: 32px;
    padding: 6px 16px;
    margin-top: 4px;
    margin-bottom: 16px;
    border-radius: 25px;
    width: 100%;
  }
  .ant-input-suffix {
    top: 38%;
  }
`

export const RequiredSpan = styled.span`
  color: #e61737;
  margin: 0 5px;
`

export const BottomButtons = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 12px;
`

export const SaveButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  border: none;
  box-shadow: 1px 2px 3px -1px #aaaaaa;
  color: ${WHITE};
  background: ${BLUE};
  @media (max-width: 767px) {
    margin-top: 28px;
    width: 100%;
    margin-right: 0;
    height: 50px;
  }
`

export const CloseButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  box-shadow: 1px 2px 4px -1px #d4d4d4;
  margin-top: 12px;
  border: 1px solid #ececec;
`

export const InfoBody = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: -38px;
`

export const InfoTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  margin-left: -22px;
`

export const InfoIcon = styled(Icon)`
  margin-right: 12px;
`

export const InfoDescription = styled.div`
  margin-top: 24px;
  font-size: 15px;
  center {
    font-size: 16px;
  }
  ul {
    padding-left: 15px;
    margin-bottom: 0;
    margin-top: 18px;
  }
`

export const StyledSelectContainer = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  margin-top: var(--spacing-32);
  margin-bottom: -50px;
  align-items: center;
  z-index: 9;
  @media (max-width: 767px) {
    margin-top: 18px;
    margin-bottom: -38px;
    margin-right: 16px;
  }
`

export const StyledSelect = styled(Select)`
  width: 163px;
  transition: all .25s;
  color: var(--neutral-body);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  & .ant-select-selection {
    border: var(--border-regular) solid var(--neutral-border-med);
    background: #FFF;
    border-radius: 0;
  }
  .ant-select-selection__rendered {
    line-height: 36px;
    font-size: 12px;
    margin-left: 12px;
    margin-right: 12px;
  }
  .ant-select-selection-selected-value {
    line-height: 28px;
  }
  .ant-select-selection__placeholder {
    color: var(--neutral-body);
    line-height: 12px;
  }
  .ant-select-arrow {
      color: var(--neutral-body);
  }
  .category-option {
    color: red;
  }
`

export const ClearButton = styled.div`
  color: ${BLUE};
  margin-right: 16px;
  font-size: 14px;
  transition: all .25s;
  &:hover {
    color: ${RED};
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    margin-left: 16px;
    margin-right: unset;
  }
`

export const SizeRecCtaBand = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding-block: var(--spacing-24);
    padding-inline: 0;
    border-bottom: var(--border-regular) solid var(--neutral-border-med);
    box-sizing: border-box;
  }
  .anticon {
    font-size: 14px;
  }
`

type BannerModeProps = {
  $mode?: 'image' | 'dark' | 'light'
}

export const HeroBanner = styled.section<BannerModeProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  ${({ $mode }: BannerModeProps) => $mode === 'image'  ?
  `
    height: 385px;
    background: var(--neutral-white);
    justify-content: center;
    align-items: stretch;
  ` : `
    height: 220px;
    justify-content: center;
    align-items: stretch;
    padding-block: var(--spacing-42);
    background: ${$mode === 'light' ? 'var(--neutral-white)' : 'var(--neutral-darkest)'};
  `}
  #banner-rule {
    display: block;
    width: 42px;
    height: 2px;
    object-fit: none;
    flex-shrink: 0;
  }
  @media (max-width: 698px) {
    ${({ $mode }: BannerModeProps) => $mode === 'image' ?
    `
      height: 104px;
      min-height: 104px;
    ` : `
      padding-block: var(--spacing-32);
    `}
  }
`

export const HeroBannerInner = styled(ContentInner)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-8);
  justify-content: center;
  height: 100%;
  @media (max-width: 698px) {
    align-items: center;
    text-align: center;
  }
`

export const HeroImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`

export const BannerEyebrow = styled.p<BannerModeProps>`
  margin: 0;
  font: 500 14px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ $mode }: BannerModeProps) => $mode === 'light' ? 'var(--neutral-secondary)' : 'var(--neutral-muted)'};
  @media (max-width: 698px) {
    font: 600 12px/20px var(--font-barlow);
  }
`

export const BannerTitle = styled.h1<BannerModeProps>`
  margin: 0;
  font: 700 96px/98px var(--font-barlow-semi-condensed);
  letter-spacing: -2px;
  color: ${({ $mode }: BannerModeProps) => $mode === 'light' ? 'var(--neutral-darkest)' : 'var(--neutral-white)'};
  @media (max-width: 698px) {
    font: 700 40px/42px var(--font-barlow-semi-condensed);
    letter-spacing: 0;
    text-align: center;
  }
`

export const WelcomeBar = styled.div`
  width: 100%;
  background: var(--neutral-white);
  padding-block: var(--spacing-16);
  box-sizing: border-box;
  @media (max-width: 767px) {
    padding-block: var(--spacing-24);
  }
`

export const WelcomeBarInner = styled(ContentInner)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--spacing-12);
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-24);
  }
`

export const WelcomeTitle = styled.p`
  margin: 0;
  font: 400 20px/24px var(--font-barlow);
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--neutral-body);
  @media (max-width: 767px) {
    white-space: normal;
    width: 100%;
  }
`

export const WelcomeActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: auto;
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-8);
    width: 100%;
    margin-left: 0;
  }
`

type HeaderCtaProps = {
  $full?: boolean
  $wide?: boolean
}

export const HeaderCta = styled(SecondaryCTA)<HeaderCtaProps>`
  width: auto;
  max-width: none;
  flex: 0 0 auto;
  margin-right: var(--spacing-12);
  white-space: nowrap;
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: 767px) {
    width: 100%;
    margin-right: 0;
    ${({ $full, $wide }: HeaderCtaProps) => $full || $wide ? 'grid-column: 1 / -1;' : ''}
  }
`

export const BulletinSection = styled.section`
  width: 100%;
  background: var(--neutral-fill-lightest);
  border-top: var(--border-regular) solid var(--neutral-border-light);
  border-bottom: var(--border-regular) solid var(--neutral-border-light);
  padding-block: var(--spacing-24);
  box-sizing: border-box;
  @media (max-width: 767px) {
    padding-block: var(--spacing-32);
  }
`

export const BulletinSectionInner = styled(ContentInner)`
  display: flex;
  align-items: stretch;
  gap: 18px;
  #bulletin-accent {
    width: 3px;
    border-radius: 2px;
    background: var(--accent-red);
    flex-shrink: 0;
  }
  @media (max-width: 767px) {
    gap: var(--spacing-12);
  }
`

export const BulletinCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  max-width: 800px;
  #bulletin-eyebrow {
    margin: 0;
    font: 600 12px/20px var(--font-barlow);
    letter-spacing: 1px;
    text-transform: uppercase;
    color: var(--neutral-muted);
  }
  #bulletin-body {
    margin: 0;
    font: 400 16px/24px var(--font-inter);
    color: var(--neutral-darkest);
    white-space: pre-line;
  }
  @media (max-width: 698px) {
    gap: 6px;
    max-width: none;
  }
`

export const ReminderForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);
`

export const ReminderCopy = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  img {
    display: block;
    width: 50px;
    height: 50px;
    padding: 13px;
    box-sizing: border-box;
    object-fit: contain;
    border-radius: var(--radius-full);
    background: var(--neutral-lightest-block);
    flex-shrink: 0;
    margin-bottom: 10px;
  }
  #copy-text {
    margin: 0;
    font: 400 14px/22px var(--font-inter);
    color: var(--neutral-secondary);
  }
`

export const ReminderHeading = styled.h2`
  margin: 0 0 var(--spacing-12);
  font: 600 32px/38px var(--font-barlow-semi-condensed);
  color: var(--neutral-darkest);
  text-transform: capitalize;
`

export const ReminderField = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  width: 100%;
`

export const ReminderLabel = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--neutral-darkest);

  .required-mark {
    font: 500 14px/20px var(--font-barlow);
    letter-spacing: 1px;
    color: var(--neutral-secondary);
  }
`

export const ReminderInput = styled(InputComponent)`
  height: 44px;
  margin: 0;
  padding: 0 16px;
  background: var(--neutral-fill-lightest);
  border: var(--border-regular) solid var(--neutral-border-med);
  border-radius: 0;
  box-shadow: none;
  font: 400 14px/22px var(--font-inter);
  color: var(--neutral-darkest);
  &::placeholder {
    color: var(--neutral-muted);
  }
  &:focus,
  &:hover {
    border-color: var(--neutral-border-med);
    box-shadow: none;
  }
`

type ReminderPhoneProps = {
  $dialCode?: string
}

export const ReminderPhone = styled.div<ReminderPhoneProps>`
  width: 100%;
  .react-tel-input {
    display: flex;
    align-items: stretch;
    gap: var(--spacing-12);
    max-width: none !important;
    width: 100% !important;
    margin: 0 !important;
    font-family: var(--font-inter);
    .flag-dropdown {
      order: 1;
      position: relative;
      flex: 0 0 auto;
      background: var(--neutral-fill-lightest);
      border: var(--border-regular) solid var(--neutral-border-med);
      border-radius: 0;
      height: 44px;
      &:hover,
      &.open,
      &.open .selected-flag {
        background: var(--neutral-fill-lightest);
      }
    }
    .selected-flag {
      width: auto;
      min-width: 88px;
      height: 44px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      gap: 6px;
      .flag {
        display: block;
        position: static;
        margin: 0;
        flex-shrink: 0;
        order: 1;
      }
      &::after {
        content: '+${({ $dialCode }: ReminderPhoneProps) => $dialCode || '1'}';
        font: 600 14px/22px var(--font-inter);
        color: var(--neutral-darkest);
        order: 2;
      }
      .arrow {
        position: static;
        top: auto;
        left: auto;
        margin: 0;
        order: 3;
      }
    }
    .form-control {
      order: 2;
      flex: 1;
      width: 100% !important;
      height: 44px;
      margin: 0;
      padding: 0 16px !important;
      background: var(--neutral-fill-lightest);
      border: var(--border-regular) solid var(--neutral-border-med);
      border-radius: 0;
      font: 400 14px/22px var(--font-inter);
      color: var(--neutral-darkest);
      &::placeholder {
        color: var(--neutral-muted);
      }
      &:focus {
        border-color: var(--neutral-border-med);
        box-shadow: none;
      }
    }
    .country-list {
      left: 0;
      top: 44px;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StoreFrontContent/styledComponents.tsx